import i18n from '../i18n';

/**
 * Rol + jins bo'yicha yagona yorliq (butun panel bo'ylab bir xil):
 *  - Ota-ona:  erkak → "Ota",  ayol → "Ona",  jins yo'q → "Ota-ona"
 *  - O'qituvchi: erkak → "Ustoz", ayol → "O'qituvchi", jins yo'q → "O'qituvchi"
 * Jins ma'lum bo'lsa hech qachon umumiy "Ota-ona/O'qituvchi" ko'rsatilmaydi.
 *
 * Sof funksiya (komponent emas) — shuning uchun hook o'rniga i18n instansiyasi
 * ishlatiladi (chaqirilgan paytdagi joriy tildagi yorliqni beradi).
 */
export type Gender = 'MALE' | 'FEMALE' | null | undefined;

export interface RoleLabel { label: string; color: string }

export function genderRoleLabel(role?: string | null, gender?: Gender): RoleLabel | null {
  if (!role) return null;
  if (role === 'PARENT') {
    if (gender === 'MALE') return { label: i18n.t('genderRole.father'), color: 'teal' };
    if (gender === 'FEMALE') return { label: i18n.t('genderRole.mother'), color: 'pink' };
    return { label: i18n.t('genderRole.parent'), color: 'grape' };
  }
  if (role === 'TEACHER' || role === 'HOMEROOM_TEACHER') {
    if (gender === 'MALE') return { label: i18n.t('genderRole.teacherMale'), color: 'blue' };
    if (gender === 'FEMALE') return { label: i18n.t('genderRole.teacher'), color: 'cyan' };
    return { label: i18n.t('genderRole.teacher'), color: 'blue' };
  }
  return null;
}
